module.exports = __webpack_public_path__ + "media/images/meta/kazu-blogs-5e86616cf39dafadf05c5585a61c1898.jpg";